import React from 'react';
import {
    Card,
    Row,
    Col,
    Button,
    Menu,
    Dropdown,
    Image
} from "antd";
import { useDispatch } from 'react-redux';
import fileUtils from "../../../utils/file-utils";
import { EditOutlined, DeleteOutlined, LinkOutlined, FolderOpenOutlined, DownloadOutlined, EyeOutlined  } from '@ant-design/icons';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const { Meta } = Card;

function getValue(value) {
    return value.id
}

const SortableItem = ({ value, onRemove, groupValue, onEdit, embedMenuList, editMenuList, openMenuList, moveFile, onDownload }) => {
    const folderFlag = value.folder;
    const attachImage = value.fileName;
    const valueData = value;
    const path = value.path
    const id = getValue(value);
    const [{ isDragging }, dragRef] = useDrag(
        () => ({
            type: "image",
            item: value,
            collect: (monitor) => ({
                isDragging: monitor.isDragging()
            })
        }),
        []
    );

    const [{ isOver }, dropRef] = useDrop(() => ({
        accept: "image",
        drop: (item) => dropFunct(item)
    }));

    const dropFunct = async (itemMove) => {
        // console.log("itemMove, value =>", itemMove, value);
        moveFile(itemMove, value);
    }

    const menuList = (
        <Menu>
            <Menu.Item key="embedMenuList">
                <a key="embedClick" onClick={() => embedMenuList(id)}>
                    <LinkOutlined /> Embed
                </a>
            </Menu.Item>
            <Menu.Item key="editMenuList">
                <a key="editClick" onClick={() => editMenuList(valueData)}>
                    <EditOutlined /> แก้ไข
                </a>
            </Menu.Item>
            <Menu.Item key="downloadMenuList">
                <a key="downloadClick" onClick={() => onDownload(valueData)}>
                    <DownloadOutlined /> ดาวน์โหลด
                </a>
            </Menu.Item>
            <Menu.Item key="deleteMenuList">
                <a key="removeClick" onClick={() => onRemove(id)}>
                    <DeleteOutlined /> ลบ
                </a>
            </Menu.Item>
        </Menu>
    );

    const menuDocumentList = (
        <Menu>
            <Menu.Item key="openMenuList">
                <a key="embedClick" onClick={() => openMenuList(valueData)}>
                    <FolderOpenOutlined /> เปิด
                </a>
            </Menu.Item>
            <Menu.Item key="editMenuList">
                <a key="editClick" onClick={() => editMenuList(valueData)}>
                    <EditOutlined /> แก้ไข
                </a>
            </Menu.Item>
        </Menu>
    );

    return (
        <>
            {folderFlag ?
                <div ref={dropRef} onDoubleClick={() => openMenuList(valueData)}>
                    <Dropdown overlay={menuDocumentList} trigger={['contextMenu']}>
                        <Card
                            style={{ marginTop: 16 }}
                            type="inner"
                        >
                            <Row >
                                <Col span={2}>
                                    <img src="/assets/icon-folder.png" style={{ height: '50px' }} />
                                </Col>
                                <Col span={19} style={{ paddingTop: '16px' }}>
                                    <p className="mb-0" >{valueData.fileName ? <Meta title={valueData.fileName} /> : <Meta title={valueData.folderName} />}</p>
                                </Col>
                                <Col className="d-flex" span={3} style={{ textAlign: 'center', paddingTop: '16px' }}>
                                    <Button type="text" size="large" onClick={() => onEdit(valueData)}>
                                        <EditOutlined />
                                    </Button>
                                    <Button type="text" size="large" onClick={() => onRemove(id)}>
                                        <DeleteOutlined />
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    </Dropdown>
                </div>
                :
                <div
                    key={`card-${id}`}
                    className="site-dropdown-context-menu"
                    ref={dragRef}
                >
                    <Dropdown overlay={menuList} trigger={['contextMenu']}>
                        <Card
                            style={{ marginTop: 16 }}
                            type="inner"
                        >
                            <Row >
                                <Col span={2} >
                                    <Image style={{ height: '50px' }} src={fileUtils.getGalleryRenderUrl(groupValue, path, attachImage)} />
                                </Col>
                                <Col span={15} style={{ paddingTop: '16px' }}>
                                    <p className="mb-0" >{valueData.fileName ? <Meta title={valueData.fileName} /> : <Meta title={valueData.folderName} />}</p>
                                </Col>
                                <Col span={4} style={{ paddingTop: '16px' }}>
                                    <p className="mb-0" > <EyeOutlined/>{` ${valueData.totalView?valueData.totalView:0}`} </p>
                                </Col>
                                <Col className="d-flex" span={3} style={{ textAlign: 'center', paddingTop: '16px' }}>
                                    <Button type="text" size="large" onClick={() => onEdit(valueData)}>
                                        <EditOutlined />
                                    </Button>
                                    <Button type="text" size="large" onClick={() => onRemove(id)}>
                                        <DeleteOutlined />
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    </Dropdown>
                </div>
            }
        </>
    );
};

const ListCardGalleryPhoto = ({ items, onRemove, groupValue, onEdit, embedMenuList, editMenuList, openMenuList, moveFile, onDownload }) => {
    return (
        <Row>
            <Col span={24}>
                <DndProvider backend={HTML5Backend}>
                    {items.map((value, index) => (
                        <SortableItem
                            key={`sortable-${getValue(value)}`}
                            index={index}
                            value={value}
                            onRemove={onRemove}
                            groupValue={groupValue}
                            onEdit={onEdit}
                            embedMenuList={embedMenuList}
                            editMenuList={editMenuList}
                            openMenuList={openMenuList}
                            moveFile={moveFile}
                            onDownload={onDownload}
                        />
                    ))}
                </DndProvider>
            </Col>
        </Row>
    );
};


export default ListCardGalleryPhoto;
